<template>

  <el-dialog
    title="Online Ödeme Entegrasyon"
    :visible="Modal"
    center
    width="70%">
    <a @click="$emit('Modal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-form :model="FormData" @submit.prevent.native="Submit" class="mt-3" :rules="FormHata" ref="Form">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Banka Hesap Ünvanı" prop="HesapAdi">
            <el-input v-model="FormData.HesapAdi"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="İrtibat E-Mail" prop="Email">
            <el-input v-model="FormData.Email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="İrtibat Telefon No" prop="Telefon">
            <el-input v-model="FormData.Telefon" v-mask="'### ### ## ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Banka Hesap IBAN" prop="Iban">
            <el-input v-model="FormData.Iban" v-mask="'TR ## #### #### #### #### #### ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item class="Tooltip" label="Kasa" prop="Kasa_id">

            <el-tooltip class="item" effect="dark" content="Pos ile tahsil edilen bakiye hangi kasada gözükecek"
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-cascader
              placeholder="Kasa Seçiniz"
              :props="{ multiple: false}"
              :options="Kasalar"
              v-model="FormData.Kasa_id"
              collapse-tags
              filterable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="Tooltip" label="Komisyonsuz" prop="Komisyon">
            <el-tooltip class="item" effect="dark" content="Tek çekimde komisyon anaparadan kesilsin."
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-switch v-model="FormData.Komisyon"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="Tooltip" label="Durum" prop="Durum">
            <el-tooltip class="item" effect="dark" content="Özel Pos durumu"
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-switch v-model="FormData.Durum"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-alert
      type="info"
      :closable="false"
      description="Vergi Dairesi, Vergi No, Adres bilgileri Sistem ayar bilgisinden alınacaktır."
    >
    </el-alert>
    <div v-if="Pos_id">
      <hr>
      <el-alert
        :type="Durum.Type"
        :closable="false"
        :description="Durum.Aciklama"
      ></el-alert>
      <hr>
      <table class="table table-hover table-bordered">
        <thead>
        <tr>
          <th>Pos Paket</th>
          <th class="text-right">Tek Çekim</th>
          <th class="text-right">2 Taksit</th>
          <th class="text-right">3 Taksit</th>
          <th class="text-right">4 Taksit</th>
          <th class="text-right">5 Taksit</th>
          <th class="text-right">6 Taksit</th>
          <th class="text-right">7 Taksit</th>
          <th class="text-right">8 Taksit</th>
          <th class="text-right">9 Taksit</th>
          <th class="text-right">10 Taksit</th>
          <th class="text-right">11 Taksit</th>
          <th class="text-right">12 Taksit</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ FormData.PaketAdi }}</td>
          <td class="text-right">%{{ FormData.Taksit1 }}</td>
          <td class="text-right">%{{ FormData.Taksit2 }}</td>
          <td class="text-right">%{{ FormData.Taksit3 }}</td>
          <td class="text-right">%{{ FormData.Taksit4 }}</td>
          <td class="text-right">%{{ FormData.Taksit5 }}</td>
          <td class="text-right">%{{ FormData.Taksit6 }}</td>
          <td class="text-right">%{{ FormData.Taksit7 }}</td>
          <td class="text-right">%{{ FormData.Taksit8 }}</td>
          <td class="text-right">%{{ FormData.Taksit9 }}</td>
          <td class="text-right">%{{ FormData.Taksit10 }}</td>
          <td class="text-right">%{{ FormData.Taksit11 }}</td>
          <td class="text-right">%{{ FormData.Taksit12 }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!Pos_id">Oranlar ve diğer detaylar kayıt olduktan sonra burada gözükecektir.</div>
    <div slot="footer" class="dialog-footer">
      <div class="entegre">
        <a href="https://sipay.com.tr/" target="_blank">
          <img src="https://cdn.mudu.pro/Design/sipay-logo.png">
        </a>
        <h5>BDDK Yetkili ödeme kuruluşu Sipay alt yapısı ve güvencesi ile çalışmaktadır.<br>Ödemeler her hafta Çarşamba
          günü belirttiğiniz hesap bilgilerine Sipay tarafından gönderilmektedir.</h5>
      </div>
      <el-button v-if="!lo" class="float-right" type="primary" size="medium" @click="Submit()"
                 icon="el-icon-check">{{ $t('eGenel.0') }}
      </el-button>
      <div class="clearfix"></div>
    </div>
  </el-dialog>
</template>

<script>


import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  props: ['Modal'],
  components: {Yukleniyor},
  data() {
    return {
      lo: true,
      Kasalar: null,
      Pos_id: null,
      FormData: {
        HesapAdi: null,
        Email: null,
        Durum: true,
        Telefon: null,
        Iban: null,
        Kasa_id: null,
        Komisyon: false,
        VergiDairesi: null,
        VergiNo: null,
        Adres: null,
      },
      Durum: {
        "Type": "error",
        "Aciklama": "Özel Pos Pasif"
      },
      FormHata: {
        HesapAdi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Email: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Iban: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
    }
  },
  methods: {
    Submit() {
      this.$store.dispatch("Post", {
        ...this.FormData,
        path: 'entegrasyon/pos'
      }).then(response => {
        if (response.Durum == "OK") {
          this.SayfaYukle();
          this.$message.success(response.Mesaj);
        } else {
          this.$message.error(response.Mesaj);
          this.hata = response.Hata;
        }
      })
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'entegrasyon/pos'})
        .then(response => {
          this.lo = false;
          if (response.Status === 'OK') {
            this.FormData = response;
            this.Pos_id = response.id;
            if (response.Paratika) {
              // ÖDEME KURUMUNA KAYDI YAPILDIYSA
              if (response.Durum) {
                this.Durum = {
                  "Type": "success",
                  "Aciklama": "Pos Aktif"
                }
              } else {
                this.Durum = {
                  "Type": "error",
                  "Aciklama": "Pos Pasif"
                }
              }
            } else {
              this.Durum = {
                "Type": "warning",
                "Aciklama": "Başvurunun ödeme kurumu tarafından onaylanması bekleniyor."
              }
            }
          }
        });
    }
  },
  created() {
    this.SayfaYukle();
    this.$store.dispatch("Get", {path: 'muhasebe/kasa/'})
      .then(response => {
        if (response.Durum === 'OK') {
          this.Kasalar = response.Liste
        } else {
          this.$message.error(response.Mesaj);
          this.hata = response.Hata;
        }
      });
    this.lo = false;
  }
}
</script>

<style scoped>
.entegre {
  display: inline-block;
  float: left;
  text-align: left;
}

.entegre h5 {
  font-size: 10px;
}

button {
  margin-top: 15px;
}

.entegre img {
  width: 70px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pack/Entegrasyon/SanalPosEntegrasyon.vue